/**
 * Private helper to convert array of objects to CSV string
 */
const toCsv = (data, delimiter = ',') => {
    if (!data?.length) return '';

    const headers = Object.keys(data[0]).join(delimiter);

    const rows = data.map(row =>
        Object.values(row)
            .map(v => {
                // 1. Ako je null ili undefined, vrati prazno
                if (v === null || v === undefined) return '';

                // 2. Ako je broj, vrati ga čistog (bez navodnika)
                if (typeof v === 'number') return v;

                const val = String(v);

                // 3. Ako string sadrži zarez, razmak ili već ima navodnike,
                // uokviri ga jednom i eskejpuj unutrašnje navodnike
                if (val.includes(delimiter) || val.includes(' ') || val.includes('"')) {
                    return `"${val.replace(/"/g, '""')}"`;
                }

                // 4. Za proste stringove bez razmaka (npr. CAMERA), vrati bez navodnika
                return val;
            })
            .join(delimiter)
    );

    return '\ufeff' + [headers, ...rows].join('\n');
};

/**
 * Private helper to trigger browser download
 */
const downloadCsv = (csv, filename = 'export.csv') => {
    const blob = new Blob([csv], {
        type: 'text/csv;charset=utf-8;'
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = filename;
    document.body.appendChild(link); // Required for some Firefox versions
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
};

export const formatCollectionPeriod = (period) => {
    if (!period || !period.dateRange || period.dateRange.length < 2) return "";

    // Bukvalno izvlačenje datuma (bez timezone pomeraja)
    const toDDMMYYYY = (iso) => {
        if (!iso) return '';
        const dateOnly = iso.split('T')[0];
        const [year, month, day] = dateOnly.split('-');
        return `${day}.${month}.${year}`;
    };

    const startDate = toDDMMYYYY(period.dateRange[0]);
    const endDate = toDDMMYYYY(period.dateRange[1]);
    const datePart = `${startDate}-${endDate}`;

    /**
     * MULTIPLE TIME RANGES
     * Prolazimo kroz ceo niz i spajamo ih: "06:00-10:00, 16:00-20:00"
     */
    const timePart = period.timeRanges?.length
        ? period.timeRanges.map(t => `${t.startTime}-${t.endTime}`).join(',')
        : "";

    // Finalni format: "22.09.2025-22.10.2025, 00:00-23:59, 10:00-12:00"
    return `${datePart},${timePart}`;
};

/**
 * MAIN EXPORT: The only function you usually need to call
 */
export const exportCsvFile = ({
                                  data,
                                  mapper,
                                  filename = 'export.csv',
                                  delimiter = ','
                              }) => {
    if (!data || !data.length) {
        console.warn('Export failed: No data provided');
        return;
    }

    // Apply mapper if provided, otherwise use raw data
    const rows = mapper ? data.map(mapper) : data;
    const csv = toCsv(rows, delimiter);
    downloadCsv(csv, filename);
};